import React from 'react'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/fe-toolbox'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
  HeaderBarRightAction,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon-v2'

import {
  useConversationStore,
  useConversationMessageStore,
} from 'stores/conversation'
import { useSETrackEvent } from 'app/ConversationPage/hooks/useSETrackEvent'
import { AbortRequestService } from 'app/ConversationPage/utils/api'

const ConversationHeader = () => {
  const router = useRouter()
  const { hasConversationId, conversationId } = useConversationStore()
  const { setConfirmSheetOpen } = useConversationMessageStore()
  const { SETrackConversationPage } = useSETrackEvent()
  const abortController = AbortRequestService.getInstance()

  const startNewSessionHandler = React.useCallback(() => {
    setConfirmSheetOpen(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const clickLearnMoreHandler = () => {
    SETrackConversationPage('CLICK_GURU_AI_PELAJARI_LEBIH_LANJUT', {
      ai_chat_session_id: conversationId,
      is_new_ai_chat_session: [true, 'bool'],
    })
  }

  return (
    <>
      <HeaderBar fixed>
        <HeaderBarLeftAction
          data-testid="conversation-back-button"
          icon={<Icon>close</Icon>}
          onClick={() => {
            abortController.abortRequest()
            historyUtils.backToApp(() => {
              const isNewActivity = window.history.length <= 2
              if (isNewActivity) router.push('/home')
              else router.back()
            })
          }}
        />
        <HeaderBarTitle subtitle="Beta">Asisten Guru</HeaderBarTitle>
        <HeaderBarRightAction type="text" className="whitespace-nowrap">
          {hasConversationId() ? (
            <button onClick={startNewSessionHandler} className="font-semibold">
              Mulai diskusi baru
            </button>
          ) : (
            <>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href="https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/sections/28896643862553-Tentang-Asisten-Guru"
                target="_blank"
                onClick={clickLearnMoreHandler}
              >
                Pelajari panduan
              </a>
            </>
          )}
        </HeaderBarRightAction>
      </HeaderBar>
    </>
  )
}

export default ConversationHeader
